import React, { useState } from 'react';
import { X, LifeBuoy, CheckCircle2 } from 'lucide-react';
import api from '../api';
import './ConfirmModal.css';

// Modale "Contatta l'assistenza": il fornitore scrive un messaggio che viene
// inviato via email allo staff (POST /auth/assistenza).
function SupportModal({ open, onClose }) {
  const [messaggio, setMessaggio] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  if (!open) return null;

  const chiudi = () => {
    if (sending) return;
    setMessaggio('');
    setSent(false);
    setError(null);
    onClose();
  };

  const invia = async () => {
    setError(null);
    if (!messaggio.trim()) { setError('Scrivi un messaggio prima di inviare.'); return; }
    setSending(true);
    try {
      await api.post('/auth/assistenza', { messaggio });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.errore || 'Errore nell\'invio. Riprova.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={chiudi} role="dialog" aria-modal="true">
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={chiudi} aria-label="Chiudi">
          <X size={20} />
        </button>

        {sent ? (
          <>
            <div className="modal-icon"><CheckCircle2 size={26} /></div>
            <h3 className="modal-title">Richiesta inviata</h3>
            <p className="modal-message">Grazie! Ti risponderemo via email il prima possibile.</p>
            <div className="modal-actions">
              <button type="button" className="btn btn-primary" onClick={chiudi}>Chiudi</button>
            </div>
          </>
        ) : (
          <>
            <div className="modal-icon"><LifeBuoy size={26} /></div>
            <h3 className="modal-title">Contatta l'assistenza</h3>
            <p className="modal-message">Scrivici il tuo problema o la tua domanda: ti risponderemo via email.</p>
            {error && <div className="error-message" style={{ marginBottom: '0.75rem' }}>{error}</div>}
            <textarea
              className="support-textarea"
              rows="5"
              placeholder="Descrivi qui come possiamo aiutarti…"
              value={messaggio}
              onChange={(e) => setMessaggio(e.target.value)}
              maxLength={3000}
              disabled={sending}
            />
            <div className="modal-actions">
              <button type="button" className="btn btn-secondary" onClick={chiudi} disabled={sending}>Annulla</button>
              <button type="button" className="btn btn-primary" onClick={invia} disabled={sending}>
                {sending ? 'Invio…' : 'Invia richiesta'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SupportModal;
